class RouteValueKeys {
  static minDate = "mi";

  static maxDate = "mx";

  static regions = "r";

  static excludedRegions = "er";

  static packageTypes = "p";

  static productionTypes = "pr";
}

export default RouteValueKeys;
